import { useRef } from 'react'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from '../../configs'
import { MsalBridge } from '../MsalBridge/MsalBridge'
import { DevBypassProvider } from '../DevBypassProvider/DevBypassProvider'
import type { AuthProviderProps } from './AuthProvider.types'

export function AuthProvider({ children }: AuthProviderProps) {
  const msalRef = useRef<PublicClientApplication | null>(null)
  const isDevBypass = import.meta.env.DEV && Boolean(import.meta.env.VITE_DEV_AUTH_TOKEN)

  if (isDevBypass) {
    return <DevBypassProvider>{children}</DevBypassProvider>
  }

  if (msalRef.current === null) {
    msalRef.current = new PublicClientApplication(msalConfig)
  }

  return (
    <MsalProvider instance={msalRef.current}>
      <MsalBridge>{children}</MsalBridge>
    </MsalProvider>
  )
}
